//'use strict'
import axios from 'axios'
import requestConfig from '../../static/http/requestConfig.js'
axios.defaults.withCredentials = true

const request = axios.create({
  baseURL: process.env.BASE_API,
  timeout: requestConfig.timeout
})

// 请求前拦截
request.interceptors.request.use((conf) => {
  // 设置token
  setToken(conf.headers)
  return conf
}, (err) => {
  return Promise.reject(err)
})
/** 请求后拦截
 *  httpJsonRspInterface 业务对象
 *  httpStatusCode 业务状态
 */
const successCode = '000000'
const successXmlCode = '200'
request.interceptors.response.use(res => {
  if(res.headers['date']){
    window.sessionStorage.setItem('date',res.headers['date'])
  } 

  // 超时
  if (res.data == undefined || res.data == null || res.data == '') {
    throw new Error('Network timeout,Please try agagin later')
  }

  // ar报文
  if (undefined != res.data.httpStatusCode && successXmlCode === res.data.httpStatusCode['reasonCode']) {
    return setData(res.data)
  }
  // JSON对象
  if (undefined != res.data.httpStatusCode && successCode === res.data.httpStatusCode['reasonCode']) {
    return setData(res.data)
  }

  if (res.data.reasonCode != undefined) {
    if (res.data.authCode !== undefined) {
      throw new Error(res.data.reasonCode + ',' + res.data.reasonCodeDesc + ',' + res.data.authCode)
    } else {
      throw new Error(res.data.reasonCode + ',' + res.data.reasonCodeDesc)
    }
  }
  
  //JSON报错
  if (res.data.httpStatusCode.reasonCode !== '000000') {
    throw new Error(res.data.httpStatusCode.reasonCodeDesc)
  }

  return res.data
}, error => {
  return Promise.reject(error)
})

// 设置Token
let setToken = (headers) => {
  if (window.sessionStorage.getItem('sessionToken')) {
    headers['token'] = window.sessionStorage.getItem('sessionToken')
  }
}

// 封装前端自己的数据格式nigeng
let setData = (data) => {
  let returnData = {}
  if (data.httpJsonRspInterface) {
    returnData = data.httpJsonRspInterface
    returnData['reasonCode'] = data.httpStatusCode.reasonCode
    return returnData
  }
  return data
}

export default request



// WEBPACK FOOTER //
// ./src/utils/request.js